import parametresInterne from '@/views/configInterne/parametresInterne';
import configurationClient from '@/views/configInterne/parametresClient';
import importData from '@/views/configInterne/importData';
import exportData from '@/views/configInterne/exportData';
import sprintList from '@/views/configInterne/l_sprint';

export default [
  {
    path: '/admin-usage-interne-uniquement',
    component: parametresInterne,
    name: 'l.parametrage.general-configInterne',
  },
  {
    path: '/configurationSite',
    component: configurationClient,
    name: 'm.parametrage.general-configClient',
  },
  {
    path: '/importData',
    component: importData,
    name: 'm.parametrage.general-import',
  },
  {
    path: '/exportData',
    component: exportData,
    name: 'm.parametrage.general-export',
  },
  {
    path: '/sprint',
    component: sprintList,
    name: 'l.parametrage.sprint',
  },
];
